import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

import { CartStep, CartStepProps } from './CartStep';
import { withRouter } from 'react-router';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';

const Wrapper = styled(FlexRowCenter)`
  margin: 0;
  width: 100%;
  padding: ${rem(56)};
  background-color: ${({ theme }) => theme.colors.secondaryBackground};

  ${({ theme }) => theme.mediab.l925`
    padding: ${rem(32)} 0;
  `};
`;

const ContentWrapper = styled(FlexRowCenter)`
  margin: auto;
  width: 100%;
  ${({ theme }) => theme.mediab.l925`
    flex-direction: column;
  `};
`;

const StagesWrapper = styled(FlexRowCenter)`
  width: 100%;
`;

interface CartStepperProps {
  steps: CartStepProps[];
  location: any;
  onStepClick: (step: number) => void;
  handleChangeURL: (url, orderNumber) => void;
  currentStepNumber: number;
  pathname: string;
}

function CartStepper({
  steps,
  onStepClick,
  currentStepNumber,
  pathname,
}: CartStepperProps) {
  const getStatus = (stepUrl: string, stepNumber: number): string => {
    if (pathname === stepUrl) {
      return 'selected';
    } else if (stepNumber && stepNumber < currentStepNumber) {
      return 'done';
    }
    return 'default';
  };

  return (
    <Wrapper>
      <ContentWrapper>
        <StagesWrapper>
          {steps.map(step => {
            const { title, stepUrl, stepNumber } = step;

            return (
              <CartStep
                stepUrl={stepUrl}
                onStepClick={onStepClick}
                key={stepNumber}
                title={title}
                stepNumber={stepNumber}
                status={getStatus(stepUrl, stepNumber)}
              />
            );
          })}
        </StagesWrapper>
      </ContentWrapper>
    </Wrapper>
  );
}

const WithRouterCartStepper = withRouter(CartStepper);
export { WithRouterCartStepper as CartStepper };
